import React from 'react';
export var DaEditorContext = React.createContext(false);
DaEditorContext.displayName = 'DaEditorContext';
//# sourceMappingURL=DaEditorContext.js.map